export default "__VITE_PUBLIC_ASSET__cfccd874__"